module.exports = __webpack_public_path__ + "static/ApocalipsisZombie-3f9f0816cbd4e230ba514cd10639c869.jpg";